import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Megaphone, Copy, Check } from "lucide-react";
import { copyText } from "@/components/landing/ShareButtons";

const origin = () => window.location.origin;

const buildDays = (products) => {
  const p = (slug) => products.find((x) => x.slug === slug) || products[0] || {};
  const link = (prod, src = "whatsapp") => `${origin()}/api/share/${prod.slug || prod.product_id}?src=${src}`;
  const money = p("brainboost-money-magnet");
  const core = p("core-money-value");
  const fokus = p("brainboost-fokus-produktivitas-kerja");
  const letgo = p("brainboost-let-go-of-the-past");
  const tenang = p("brainboost-penenangan-diri");
  const parfum = p("nalura-essence-parfum-relaksasi");
  const kreatif = p("brainboost-meningkatkan-kreativitas");
  return [
    { day: "Hari 1 — Senin", theme: "Hook Masalah (Uang)", platform: "TikTok/Reels + WA",
      caption: `POV: kamu kerja keras tiap hari tapi rekening gitu-gitu aja 😮‍💨\n\nMasalahnya bukan kerja kerasmu — tapi POLA PIKIRMU tentang uang.\n\n${money.name} membantumu melihat peluang yang selama ini terlewat. Mulai hari ini, bukan nanti.\n\n👉 ${link(money)}\n\n#mindset #keuangan #selfimprovement #fyp` },
    { day: "Hari 2 — Selasa", theme: "Edukasi (Nilai Diri)", platform: "IG Carousel + WA",
      caption: `Kelimpahan yang bertahan tidak dibangun dari hustle — tapi dari FONDASI nilai diri. 🏛\n\n3 tanda fondasimu belum kuat:\n1. Uang datang, cepat habis\n2. Takut menaikkan harga/gaji\n3. Merasa "tidak pantas" sukses\n\n${core.name} membereskan akarnya.\n👉 ${link(core)}\n\n#nilaidiri #mindsetkaya #pengembangandiri` },
    { day: "Hari 3 — Rabu", theme: "Soft-sell Parfum (PO)", platform: "IG Story + Grup WA",
      caption: `Ritual relaksasi level baru 🌿\n\nRuangan + aroma = pintu menuju alam bawah sadar.\n\n${parfum.name} kini OPEN PRE-ORDER — ukuran 10ml sampai 250ml untuk ruangan luas. Harga menyusul, pemesan awal dapat prioritas!\n\n👉 ${link(parfum)}\n\n#parfumrelaksasi #selfcare #meditasi` },
    { day: "Hari 4 — Kamis", theme: "Relate & Healing", platform: "TikTok/Reels",
      caption: `"Sudah move on kok."\nTapi tiap malam masih kepikiran? 🥀\n\nLuka batin yang tidak dibereskan akan terus menyabotase masa depanmu — karier, relasi, bahkan rezeki.\n\n${letgo.name} membantumu benar-benar berdamai.\n👉 ${link(letgo)}\n\n#healing #movingon #trauma #selflove` },
    { day: "Hari 5 — Jumat", theme: "Produktivitas (Pekerja)", platform: "LinkedIn/IG + WA kantor",
      caption: `Buka laptop jam 9, tiba-tiba sudah jam 12 dan belum ada yang selesai? 🫠\n\nFokus itu bukan bakat — dia bisa DILATIH.\n\n${fokus.name}: program audio untuk deep focus & produktivitas maksimal.\n👉 ${link(fokus)}\n\n#produktivitas #fokus #worklife` },
    { day: "Hari 6 — Sabtu", theme: "Ketenangan (Weekend)", platform: "IG Story + Status WA",
      caption: `Weekend ini jangan cuma rebahan sambil scroll — pulihkan pikiranmu beneran 🍃\n\n${tenang.name} membantu meredakan cemas & stres, menghadirkan damai yang sesungguhnya.\n\nPasangkan dengan aroma menenangkan = relaksasi maksimal.\n👉 ${link(tenang)}\n\n#selfcare #ketenangan #weekendvibes` },
    { day: "Hari 7 — Minggu", theme: "Rekap + CTA Kreativitas", platform: "Semua platform",
      caption: `Minggu baru, versi dirimu yang baru ✨\n\nDi NALURA kamu bisa mulai dari mana saja:\n🧠 Pola pikir uang\n🍃 Ketenangan & healing\n🎯 Fokus kerja\n🎨 Kreativitas tanpa batas → ${kreatif.name}\n\nSemua kurasi terbaik ada di sini:\n👉 ${origin()}/bio\n\n#pengembangandiri #goodmindgoodlife` },
  ];
};

const buildTraderPosts = (products) => {
  const trader = products.find((x) => x.slug === "brainboost-trader-mindset");
  if (!trader) return [];
  const link = (src) => `${origin()}/api/share/${trader.slug}?src=${src}`;
  return [
    { day: "Trader 1 — EA", theme: "Pengguna Expert Advisor", platform: "Grup Telegram/WA Trader",
      caption: `EA kamu sudah profit konsisten... sampai kamu ikut campur 🤖📉\n\nMatiin EA pas drawdown, naikin lot pas winstreak — kenal pola ini?\n\nRobot tidak punya emosi. KAMU punya. Dan emosi yang tidak stabil adalah bug terbesar dalam sistem trading-mu.\n\n${trader.name}: bangun mindset trader profesional → emosi stabil → money management disiplin.\n\n👉 ${link("telegram")}\n\n#expertadvisor #EAtrading #forex #tradermindset` },
    { day: "Trader 2 — Copy Trading", theme: "Copy Trader", platform: "TikTok/Reels + Grup WA",
      caption: `Ikut copy trading tapi tetap rugi? 🤔\n\nMaster-nya profit, kamu malah minus. Kenapa?\n\nKarena kamu cut di saat merah, lepas copy pas drawdown, lalu FOMO masuk lagi di pucuk.\n\nMasalahnya bukan master-nya — tapi MINDSET-mu.\n\n${trader.name} melatih pikiran bawah sadarmu untuk tenang, sabar, dan percaya proses.\n\n👉 ${link("whatsapp")}\n\n#copytrading #trading #psikologitrading #fyp` },
    { day: "Trader 3 — Education", theme: "Trader yang Sedang Belajar", platform: "IG Carousel + Telegram",
      caption: `Sudah beli kelas trading mahal, hafal semua strategi... tapi masih MC juga? 📚💸\n\n90% trader gagal bukan karena ilmunya kurang — tapi karena psikologinya belum terbentuk.\n\nStrategi = 20%\nMoney management = 30%\nPSIKOLOGI & MINDSET = 50%\n\nLengkapi education-mu dengan ${trader.name} — pondasi mental trader profesional.\n\n👉 ${link("telegram")}\n\n#belajartrading #tradingeducation #psikologitrading #trader` },
  ];
};

export const PromoKit = ({ products }) => {
  const [copied, setCopied] = useState(null);
  if (!products || products.length === 0) return null;
  const days = [...buildDays(products), ...buildTraderPosts(products)];

  const copy = async (i, text) => {
    if (await copyText(text)) {
      setCopied(i);
      toast.success("Konten disalin — tinggal posting!");
      setTimeout(() => setCopied(null), 2000);
    }
  };

  return (
    <div className="mt-16" data-testid="promo-kit">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-display text-2xl tracking-tight flex items-center gap-3">
          <Megaphone className="w-5 h-5 text-[#A67C1E]" /> Kalender Konten 7 Hari
        </h2>
      </div>
      <p className="text-sm text-[#211B10]/60 mb-6 max-w-2xl">
        Amunisi promosi siap-posting. Salin, tempel ke TikTok/IG/WhatsApp sesuai jadwal — plus 3 konten bonus khusus komunitas trader (EA, Copy Trading, Education). Semua link otomatis melacak sumber klik ke dashboard Anda.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {days.map((d, i) => (
          <div key={d.day} data-testid={`promo-day-${i + 1}`} className="border border-[#211B10]/10 bg-white p-5 flex flex-col">
            <div className="flex items-center justify-between gap-3 mb-1">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#A67C1E]">{d.day}</p>
              <span className="font-mono text-[8px] uppercase tracking-[0.15em] text-[#211B10]/45 border border-[#211B10]/10 px-2 py-1">{d.platform}</span>
            </div>
            <p className="font-display text-lg tracking-tight mb-3">{d.theme}</p>
            <pre className="text-xs text-[#211B10]/70 whitespace-pre-wrap font-sans leading-relaxed bg-[#FBF7EE] border border-[#211B10]/8 p-3 mb-4 flex-1 max-h-44 overflow-y-auto">{d.caption}</pre>
            <Button
              data-testid={`copy-promo-day-${i + 1}`}
              variant="outline"
              size="sm"
              onClick={() => copy(i, d.caption)}
              className={`self-start ${copied === i ? "border-[#1B4332] text-[#1B4332] bg-[#1B4332]/10 hover:bg-[#1B4332]/10" : "border-[#A67C1E]/50 text-[#A67C1E] bg-transparent hover:bg-[#A67C1E]/10"}`}
            >
              {copied === i ? <Check className="w-3.5 h-3.5 mr-2" /> : <Copy className="w-3.5 h-3.5 mr-2" />}
              {copied === i ? "Tersalin" : "Salin Konten"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
